module.exports = __webpack_public_path__ + "media/sin440.8761a77b.wav";